import { type ConfiguratorProductData, isConfiguratorProduct } from "~/models/ProductData";
import { isProductPMA } from "~/feature/ProductDescriptor/v1/productDescriptorUtils";
import StockIndicator, { StockLevel } from "~/common/components/StockIndicator/StockIndicator";
import CircleSpinner from "~/common/components/CircleSpinner/CircleSpinner";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { type LineItem } from "~/feature/cart/cart/models/CartData";
import type { ProductDescriptor } from "~/feature/ProductDescriptor/v1/types";

export const LineItemStockIndicator = ({ product, packEntry }: { product: ProductDescriptor; packEntry: LineItem }) => {
  const quantityVisible = product.base.quantityVisible;
  return (
    <>
      {isConfiguratorProduct(product.base) ? (
        <ConfiguratorStockIndicator product={product as ProductDescriptor<ConfiguratorProductData>} />
      ) : quantityVisible && !isProductPMA(product) ? (
        <>
          {product.availability && packEntry.isInStock !== null ? (
            <StockIndicator level={packEntry.isInStock} />
          ) : product.isAvailabilityLoading ? (
            <CircleSpinner />
          ) : (
            "-"
          )}
        </>
      ) : (
        <div>{"-"}</div>
      )}
    </>
  );
};

const ConfiguratorStockIndicator = ({ product }: { product: ProductDescriptor<ConfiguratorProductData> }) => {
  const { t } = useTranslation();

  if (product.isAvailabilityLoading) {
    return <CircleSpinner />;
  }

  const leadTimeDate = product.availability?.packagingInformation[0]?.replenishmentLeadTimeDate;
  let leadTimeWeeks = null;
  if (leadTimeDate) {
    leadTimeWeeks = Math.ceil(dayjs(leadTimeDate).diff(dayjs(), "day") / 7);
  }

  if (!leadTimeWeeks) {
    return "-";
  }

  return (
    <StockIndicator
      level={StockLevel.NOT_IN_STOCK}
      changeText={t("cartPage.avaliability.leadWeeks", {
        count: leadTimeWeeks,
      })}
    />
  );
};
